module.exports = __webpack_public_path__ + "static/media/ArrowUpNewKTM.13491f52.svg";